import {
  type getMaterialBasePricesParams,
  type UpdateBasePriceBody,
  getMaterialBasePricesByYear,
  updateMaterialBasePrices,
  createNewQuarterBasePrices,
  type CreateQuarterBody,
} from "@/api/basePriceService";
import { CACHE_TIME } from "@/lib/cacheConfig";
import { queryKeys } from "@/lib/queryKeys";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useQueryInvalidation } from "@/lib/queryInvalidation";

export const useGetBasePrices = (params: getMaterialBasePricesParams) => {
  return useQuery({
    queryKey: queryKeys.basePrice.list(params),
    queryFn: () => getMaterialBasePricesByYear(params),
    staleTime: CACHE_TIME.SHORT,
  });
};

export const useUpdateBasePrices = () => {
  const invalidate = useQueryInvalidation();

  return useMutation({
    mutationFn: (data: UpdateBasePriceBody) => updateMaterialBasePrices(data),
    onSuccess: () => {
      invalidate.invalidateBasePrices();
      invalidate.invalidateMaterialCodes();
      invalidate.invalidateMaterialSuppliers();
    },
  });
};

export const useCreateNewQuarterBasePrices = () => {
  const invalidate = useQueryInvalidation();

  return useMutation({
    mutationFn: (params: CreateQuarterBody) => createNewQuarterBasePrices(params),
    onSuccess: () => {
      invalidate.invalidateBasePrices();
      invalidate.invalidateMaterialCodes();
      invalidate.invalidateMaterialSuppliers();
    },
  });
};